import { render, staticRenderFns } from "./ArticleInSaleStatus.vue?vue&type=template&id=8cc60bfc&"
import script from "./ArticleInSaleStatus.vue?vue&type=script&lang=js&"
export * from "./ArticleInSaleStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports